/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import { useState } from "react";
import { Field, Form } from 'formik';
import { Button, CircularProgress, FormControl, Grid, IconButton, InputAdornment } from '@mui/material';
import { TextField } from 'formik-mui';
import { BsFillEyeFill, BsFillEyeSlashFill } from 'react-icons/bs';

const RouterUserCreationForm = ({ values, handleBlur, handleChange, errors, touched, handleClose, isSubmitting }) => {
    const [showPassword, setShowPassword] = useState(false)



    return (

        <>
            <Form>

                <Grid container spacing={4}><Grid item xs={12} md={12} sm={12}>



                    {values.hasOwnProperty("userName") && <Grid item xs={12} md={12} sm={12}>
                        <FormControl fullWidth >

                            <Field
                                name="userName"
                                label="User Name"
                                type="text"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values.userName}
                                margin="normal"
                                variant="outlined"
                                fullWidth
                                component={TextField}
                            />
                        </FormControl>
                    </Grid>
                    }


                    {values.hasOwnProperty("password") && <Grid item xs={12} md={12} sm={12}>
                        <Grid container spacing={2}>

                            <Grid item xs={12} sm={6} md={6}>
                                <FormControl fullWidth error={Boolean(touched.password && errors.password)}>

                                    <Field
                                        name="password"
                                        label="Password"
                                        type={showPassword ? "text" : 'password'}
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        margin="normal"
                                        variant="outlined"
                                        fullWidth
                                        value={values.password}
                                        component={TextField}
                                        InputProps={{

                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        onClick={() => { setShowPassword(!showPassword) }}
                                                    >
                                                        {showPassword ? <BsFillEyeFill /> : <BsFillEyeSlashFill />}
                                                    </IconButton>
                                                </InputAdornment>
                                            )
                                        }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={6}>
                                <FormControl fullWidth error={Boolean(touched.confirmPassword && errors.confirmPassword)}>

                                    <Field
                                        value={values.confirmPassword}
                                        component={TextField}

                                        name="confirmPassword"
                                        label="Confirm Password"
                                        type={showPassword ? "text" : 'password'}
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        margin="normal"
                                        variant="outlined"
                                        fullWidth
                                        InputProps={{

                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        onClick={() => { setShowPassword(!showPassword) }}
                                                    >
                                                        {showPassword ? <BsFillEyeFill /> : <BsFillEyeSlashFill />}
                                                    </IconButton>
                                                </InputAdornment>
                                            )
                                        }}
                                    />
                                </FormControl>
                            </Grid>
                        </Grid></Grid>

                    }
                </Grid>
                    <Grid item xs={12} md={12} sm={12}>
                        <Button
                            variant="contained"
                            color="primary"
                            type="submit"
                            style={{ marginTop: '20px' }}
                            disabled={isSubmitting}>
                            {isSubmitting &&
                                <CircularProgress size={24} color='success' style={{ marginLeft: '10px' }} />} Save
                        </Button>
                        <Button variant="outlined" onClick={() => handleClose()} style={{ marginTop: '20px', marginLeft: '10px' }}>close</Button>

                    </Grid>

                </Grid>
            </Form>
        </>
    )

}
export default RouterUserCreationForm;